import { Routes } from '@angular/router';
import { MainPageComponent } from '@app/pages';
import { MenuTabComponent } from '@app/pages/main-page/menu-tab/menu-tab.component';
import { HomeTabComponent } from '@app/pages/main-page/home-tab/home-tab.component';
import { SpecialOfferComponent } from '@app/pages/main-page/special-offer/special-offer.component';
import { ServicesTabComponent } from '@app/pages/main-page/services-tab/services-tab.component';
import { MoreTabComponent } from '@app/pages/main-page/more-tab/more-tab.component';
import { NewOnTapComponent } from '@app/pages/main-page/new-on-tap/new-on-tap.component';

export const appRoutes: Routes = [
  {
    path: 'main',
    component: MainPageComponent,
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {
        path: 'home',
        component: HomeTabComponent,
        data: { animation: 'HomeTab', screen: 'Home' },
      },
      {
        path: 'menu',
        component: MenuTabComponent,
        data: { animation: 'MenuTab', screen: 'Menu' },
      },
      {
        path: 'new-on-tap',
        component: NewOnTapComponent,
        data: { animation: 'NewOnTap', screen: 'NewOnTap' },
      },
      {
        path: 'services',
        component: ServicesTabComponent,
        data: { animation: 'ServicesTab', screen: 'Services' },
      },
      {
        path: 'more',
        component: MoreTabComponent,
        data: { animation: 'MoreTab', screen: 'More' },
      },
      {
        path: 'special-offer',
        component: SpecialOfferComponent,
        data: { animation: 'SpecialOffer', screen: 'SpecialOffer' },
      },
    ],
  },
];
